<template>
  <div
    id="example1_wrapper"
    class="dataTables_wrapper form-inline dt-bootstrap"
  >
    <div
      v-if="getRoleType === 99"
      class="row"
    >
      <div class="col-sm-6 text-left">
        <div
          v-if="$route.name == 'brandTable'"
          class="form-group text-left"
        >
          <router-link :to="{ path: '/crBrand' }">
            <div class="btn btn-default btn-table-title">
              新增品牌
            </div>
          </router-link>

          <!-- 下載報表 -->
          <div class="btn btn-default btn-table-title" :disabled="show.isDownloading" @click="exportFile()">
            <i class="fa fa-download" />
            下載報表
            <clip v-show="show.isDownloading" class="cliploading" :loading="show.isDownloading" :color="'#528BB8'" :size="'16px'" />
          </div>
          <!-- End 下載報表 -->
        </div>
      </div>
      <div class="col-sm-offset-6 col-sm-6 text-right">
        <div class="form-group">
          <select class="form-control h-38">
            <option value="1">
              名稱
            </option>
          </select>
        </div>
        <div class="form-group search-bar">
          <div class="input-group">
            <input
              class="form-control"
              type="text"
              v-model="searchResult"
            />
            <span
              class="input-group-addon c-pointer"
              @click="clickPage(1)"
            >
              <i class="fa fa-search" />
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col-sm-6 text-left"></div>
      <div class="col-sm-6 text-right">
        <div class="form-group">
          <select class="form-control h-38">
            <option value="1">
              名稱
            </option>
          </select>
        </div>
        <div class="form-group search-bar">
          <div class="input-group">
            <input
              class="form-control"
              type="text"
              v-model="searchResult"
            />
            <span
              class="input-group-addon c-pointer"
              @click="clickPage(1)"
            >
              <i class="fa fa-search" />
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 table-responsive p-x-0">
        <table
          role="grid"
          id="example1"
          class="table table-bordered table-striped dataTable"
        >
          <thead>
            <tr role="row">
              <th>#</th>
              <th>品牌</th>
              <th>名稱（ID）</th>
              <th v-if="show.brand">縮寫</th>
              <th v-if="!show.menuDetail">代碼(鍵值)</th>
              <th v-if="show.brand && getRoleType === 99">
                門市數量
                <span class="nd-tooltip">
                  <i class="fa fa-question-circle" aria-hidden="true"></i>
                  <span class="nd-tooltip-text alliance-tooltip">
                    統計該品牌下目前營業中且可被搜尋到的門市總數
                  </span>
                </span>
              </th>
              <th v-if="show.brand || show.history">狀態</th>
              <th v-if="show.brand || show.history">前端</th>
              <th v-if="show.brand || show.history">刪除狀態</th>
              <th>你訂聯盟</th>
              <th v-if="show.brand && getRoleType === 99">群組</th>
              <th v-if="show.brand && getRoleType !== 10 && getRoleType !== 50">廣告</th>
              <th v-if="show.brand || show.history">店家</th>
              <th v-if="!show.history && !show.menu && !show.menuDetail && getRoleType !== 10 && getRoleType !== 50"></th>
              <th v-if="show.menuDetail"></th>
              <th v-if="show.menuDetail"></th>
              <th v-if="show.menuDetail"></th>
              <th v-if="show.menuDetail"></th>
              <th v-if="show.menuDetail"></th>
              <th v-if="show.menuDetail"></th>
              <th v-if="show.menuDetail">店家</th>
              <th v-if="show.activity"></th>
            </tr>
          </thead>
          <tbody v-if="isLoading">
            <tr>
              <td
                colspan="12"
                class="text-center"
              >
                資料讀取中...
              </td>
            </tr>
          </tbody>
          <tbody v-else-if="brandList.length">
          <tr
            v-for="(brand, index) in brandList"
            class="even"
            role="row"
          >
            <td class="sorting_1">
              {{ index + 1 }}
            </td>
            <td>
              <a
                :href="webDomain + 'brand/' + brand.brand_code"
                target="_blank"
              >
                <img
                  class="img-brand-table"
                  :src="brand.image_name"
                />
              </a>
            </td>
            <td>
              <router-link
                v-if="show.brand"
                :to="{ path: '/brandInfo/' + brand.id }"
              >
                {{ brand.name }} ({{ brand.id }})
              </router-link>
              <span v-if="!show.brand">
                {{ brand.name }} ({{ brand.id }})
              </span>
            </td>
            <td v-if="show.brand">
              {{ brand.name_short }}
            </td>
            <td v-if="!show.menuDetail">
              {{ brand.brand_code }}({{ brand.brand_key }})
            </td>
            <!-- 門市數量 -->
            <td v-if="show.brand && getRoleType === 99">
              {{ brand.store_amount || 0 }}
            </td>
            <!-- End 門市數量 -->
            <td v-if="show.brand || show.history">
              <span
                v-if="brand.is_opening"
                class="label label-success"
              >
                已上架
              </span>
              <span
                v-if="!brand.is_opening"
                class="label label-danger"
              >
                未上架
              </span>
            </td>
            <td v-if="show.brand || show.history">
              <span
                v-if="brand.is_visible"
                class="label label-success"
              >
                顯示
              </span>
              <span
                v-if="!brand.is_visible"
                class="label label-danger"
              >
                隱藏
              </span>
            </td>
            <td v-if="show.brand || show.history">
              <span
                v-if="!brand.is_delete"
                class="label label-success"
              >
                未刪除
              </span>
              <span
                v-if="brand.is_delete"
                class="label label-danger"
              >
                刪除
              </span>
            </td>
            <td>
              <span
                v-if="brand.nidin_league_levels.length"
                v-for="(level, index) in brand.nidin_league_levels"
                :key="index"
                :class="level === 1?'label label-primary mr-1':'label label-warning mr-1'"
              >
                {{level === 1?'等級一':'等級二'}}
              </span>
              <span
                v-else
              >
                -
              </span>
            </td>
            <td v-if="show.brand && getRoleType === 99">
              <router-link :to="{ path: '/groupTable/' + brand.id }">
                <button class="btn btn-default">
                  <i class="fa fa-object-group" />
                </button>
              </router-link>
            </td>
            <td v-if="show.brand && getRoleType !== 10 && getRoleType !== 50">
              <router-link :to="{ path: '/brandAdTable/' + brand.id }">
                <button class="btn btn-default">
                  <i class="fa fa-file-image-o" />
                </button>
              </router-link>
            </td>
            <td v-if="show.brand">
              <router-link :to="{ path: '/storeTable/' + brand.id }">
                <button class="btn btn-default">
                  <i class="fa fa-home" />
                </button>
              </router-link>
            </td>
            <td v-if="show.history">
              <router-link :to="{ path: '/storeHistoryTable/' + brand.id }">
                <button class="btn btn-default">
                  <i class="fa fa-home" />
                </button>
              </router-link>
            </td>
            <td v-if="show.brand && getRoleType !== 10 && getRoleType !== 50">
              <router-link :to="{ path: '/upBrand/' + brand.id }">
                <button class="btn btn-default">
                  <i class="fa fa-pencil" />
                </button>
              </router-link>
            </td>
            <td v-if="show.menuDetail">
              <router-link :to="{ path: '/brandMenu/' + brand.id }">
                <button class="btn btn-default">
                  <i class="fa fa-plus-square" />
                  配料庫
                </button>
              </router-link>
            </td>
            <td v-if="show.menuDetail">
              <router-link :to="{ path: '/brandMenuTable/' + brand.id }">
                <button class="btn btn-default">
                  <i class="fa fa-wrench" />
                  菜單建置
                </button>
              </router-link>
            </td>
            <td v-if="show.menuDetail">
              <router-link :to="{ path: '/storeTable/productImage/' + brand.id }">
                <button class="btn btn-default">
                  <i class="fa fa-picture-o" />
                  圖片庫
                </button>
              </router-link>
            </td>
            <td v-if="show.menuDetail">
              <router-link :to="{ path: '/storeTable/productSetting/' + brand.id }">
                <button class="btn btn-default">
                  <i class="fa fa-certificate" />
                  別名 / 描述 / 警語
                </button>
              </router-link>
            </td>
            <td v-if="show.menuDetail">
              <router-link :to="{ path: '/cupDiscountTable/' + brand.id }">
                <button class="btn btn-default flex align-center ">
                  <img src="../../../../assets/icon/i_reusable_cup_black.svg" />
                  <span class="text-center">自備飲料杯管理</span> 
                </button>
              </router-link>
            </td>
            <td v-if="show.menuDetail">
              <router-link :to="{ path: '/brandScheduleTable/' + brand.id }">
                <button class="btn btn-primary">
                  <i class="fa fa-clock-o" />
                  排程
                </button>
              </router-link>
            </td>
            <td v-if="show.menuDetail">
              <router-link :to="{
                name: 'StoreMenu',
                params: {
                  brand_id: brand.id,
                },
                query: {
                  back_page: tableIndex
                }
              }">
                <button class="btn btn-default">
                  <i class="fa fa-home" />
                </button>
              </router-link>
            </td>
            <td v-if="show.activity">
              <router-link :to="{ path: '/activityScheduleTable/' + brand.id }">
                <button class="btn btn-default">
                  <i class="fa fa-info-circle" />
                </button>
              </router-link>
            </td>
            <td v-if="show.schedule">
              <router-link :to="{ path: '/brandScheduleTable/' + brand.id }">
                <button class="btn btn-default">
                  <i class="fa fa-info-circle" />
                </button>
              </router-link>
            </td>
          </tr>
          </tbody>
          <tbody v-else-if="brandList.length === 0">
            <tr style="background-color: white">
              <td
                rowspan="1"
                colspan="12"
                style="text-align: center; padding-bottom: 80px; padding-top:80px;"
              >
                <img
                  src="/static/img/noMatchdata.svg"
                  style="max-width: 148px;"
                  class="center-block logo"
                />
                <span style="margin-bottom: 80px; color: #696969;">
                  沒有符合的資料
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <paginate
        :pageAmount="pageAmount"
        :total="total"
        :isActive="isActive"
        :groupAmount="groupAmount"
        :clickPage="clickPage"
        ref="brandPaginate"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
export default{
  name: 'BrandTableTemp',
  data () {
    return {
      show: {
        activity: false,
        brand: false,
        history: false,
        isDownloading: false,
        menu: false,
        menuDetail: false,
        schedule: false
      },
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      total: 1,
      count: 10,
      brandList: [],
      searchResult: '',
      isLoading: true,
      retry: 0,
      retryTimer: null,
      retryFrequency: 0
    }
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    pageAmount () {
      return Math.ceil(this.total / this.count)
    },
    webDomain () {
      return this.$config.web
    }
  },
  created () {
    const path = this.$route.name
    if (this.$route.query.name) this.searchResult = this.$route.query.name
    if (this.$route.query.page) this.tableIndex = this.$route.query.page
    if (path === 'brandTable') this.show.brand = true
    else if (path === 'menuTable') this.show.menu = true
    else if (path === 'scheduleTable') this.show.schedule = true
    else if (path === 'brandHistoryTable') this.show.history = true
    else if (path === 'menuDetailTable') this.show.menuDetail = true
    else if (path === 'brandActivityTable') this.show.activity = true
    this.getBrandList()
  },
  mounted () {
    this.$refs.brandPaginate.tableIndex = this.tableIndex
    this.$refs.brandPaginate.pageGroup = this.pageGroup
  },
  methods: {
    ...mapActions(['setBrandId', 'setBrands']),
    isActive (index) {
      if (Number(this.tableIndex) === index) return true
      else return false
    },
    clickPage (index) {
      this.tableIndex = index
      this.getBrandList()
    },
    /** 下載報表 */
    exportFile () {
      console.log({
        component: this.$options.name,
        function: 'exportFile',
        payload: {},
        time: moment().format('YYYY/MM/DD HH:mm:ss')
      })

      this.isDownloading = true
      let query = this.$route.query
      let searchParams = ''
      if (query.page) delete query.page
      if (query.size) delete query.size
      if (this.retry === 1) query.retry = 1
      if (query && typeof query === 'object' && Object.keys(query).length) searchParams = new URLSearchParams(query)
      const url = `/brand/brandListSheetSche${searchParams.toString() ? '?' + searchParams.toString() : ''}`
      this.getDataH('get', url, null, (res) => {
        if (res.data.sche_info.status === 3) {
          this.show.isDownloading = false
          this.retry = 0
          const el = document.createElement('a')
          el.href = res.data.sche_info.file_url
          el.download = `品牌門市報表.zip`
          document.body.appendChild(el)
          el.click()
          clearTimeout(this.retryTimer)
          this.retryFrequency = 0
        } else if (res.data.sche_info.status === 9) {
          this.show.isDownloading = false
          if (this.retryFrequency > 3) {
            alert('請聯絡客服或等24小時候再試')
            return false
          }
          const yes = confirm('輸出未完成，請聯絡客服或再試一次。')
          if (yes) this.retryFrequency++
          clearTimeout(this.retryTimer)
        } else {
          this.retry = 1
          this.retryTimer = setTimeout(this.exportFile, 6000)
        }
      })
    },
    getBrandList () {
      this.isLoading = true
      let data = {
        page: this.tableIndex,
        size: this.count
      }
      let url = '/brand/list?size=' + data.size
      let queryValue = {}
      if (this.searchResult) {
        if (this.$route.query.name !== this.searchResult) this.tableIndex = 1
        queryValue = {...queryValue, ...{name: this.searchResult}}
        url = url + `&name=${this.searchResult}`
      }
      if (this.tableIndex) {
        queryValue = {...queryValue, ...{page: this.tableIndex}}
        url = url + `&page=${this.tableIndex}`
      }
      this.$router.replace({query: queryValue})
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          this.brandList = response.data.list
          if (response.data.list && response.data.list.length) {
            this.$store.commit('SET_BRAND_ID', response.data.list[0].id)
            this.$store.commit('SET_BRANDS', response.data.list)
          }
          this.total = response.data.list_total
          this.isLoading = false
        }
      })
    }
  }
}
</script>
<style scoped>
.mr-1{
  margin-right: 4px;
}
</style>



// WEBPACK FOOTER //
// BrandTableTemp.vue?4447a604